import type { AuthenticationStateModel } from './auth.state';

export class SetAuthData {
  static readonly type = '[Auth] Auth data';
  constructor(readonly payload: AuthenticationStateModel) {}
}

export class Logout {
  static readonly type = '[Auth] Logout';
}
